import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ReferralRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleReferral = async () => {
      try {
        const res = await fetch(`${API_URL}/api/referral/${slug}?track=click`);
        if (res.ok) {
          localStorage.setItem('referral_slug', slug);
        }
      } catch (err) {
        // Silent fail - still redirect to register
      }
      navigate('/register', { replace: true });
    };
    handleReferral();
  }, [slug, navigate]);

  return null;
}
